import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import AppInput from "./AppInput";
import AppLogo from "../AppLogo";
import ChangeLangButton from "../language/ChangeLangButton";
import LogoWithLanguage from "../logo-with-language/LogoWithLanguage";
type ResetPasswordFormProps = {
  title: string;
  subtitle?: string;
  actionTitle?: any;
  onReset: any;
};

function ResetPasswordForm(props: ResetPasswordFormProps) {
  const LocalBasePath = "page.passwordReset";
  const { title, subtitle, actionTitle, onReset } = props;
  //   TO USE FOR TRANSLATION:  {t(`${LocalBasePath}.`)} replace your key after dot
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm();
  const onSubmit = (data: any) => {
    onReset(data);
  };

  const PASSWORD_LENGTH = 8;
  const wrongPasswordMessage = t("errors.input.wrongPasswordFormat", {
    number: PASSWORD_LENGTH,
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)} data-cy="set-password-form">
      <div className="w-full pb-2 border-b border-gray-200">
        <LogoWithLanguage />
        <div className="sm:w-full sm:max-w-md">
          <h2 className="mt-6  text-3xl font-bold text-gray-700">{title}</h2>
          {!!subtitle && (
            <p className="mt-2 text-lg w-full leading-6 text-gray-500">
              {subtitle}
            </p>
          )}
        </div>
      </div>

      <div className="sm:w-full">
        <div className="  ">
          <div className="mt-8 ">
            <div className="mt-6 divide-y divide-gray-200">
              <div className="space-y-6 mb-8 sm:max-w-md">
                <AppInput
                  label={t(`${LocalBasePath}.password`)}
                  id="newPassword"
                  placeholder="********"
                  error={errors.newPassword}
                  name="newPassword"
                  type={"password"}
                  register={register}
                  scehema={{
                    required: true,
                    minLength: {
                      value: PASSWORD_LENGTH,
                      message: wrongPasswordMessage,
                    },
                    pattern: {
                      value: /^(?=.*[a-zA-Z])(?=.*\d).{8,}$/,
                      message: wrongPasswordMessage,
                    },
                  }}
                />
                <AppInput
                  label={t(`${LocalBasePath}.confirmPassword`)}
                  id="confirmPassword"
                  placeholder="********"
                  error={errors.confirmPassword}
                  name="confirmPassword"
                  register={register}
                  type={"password"}
                  scehema={{
                    required: true,
                    minLength: {
                      value: PASSWORD_LENGTH,
                      message: wrongPasswordMessage,
                    },
                    validate: (value: any) =>
                      value === getValues("newPassword") ||
                      t("errors.input.passwordMatch"),
                  }}
                />
              </div>

              <div className="z-[999] py-5 sticky bottom-0 bg-white flex justify-between items-center flex-col-reverse sm:flex-row gap-4">
                <div className="w-full flex justify-end">
                  <button
                    data-cy="submit-password-button"
                    type="submit"
                    className="flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-base  font-medium text-white bg-brandblue-600 hover:bg-brandblue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandblue-500"
                  >
                    {!!actionTitle ? actionTitle : t(`${LocalBasePath}.reset`)}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}
export default ResetPasswordForm;
